export default {
    months: {
        one: 'month', 
        other: 'months', 
    }
};